import { isFixerLiteEnabled } from '../../annuaire/bookingState';

/**
 * Les ateliers proposés quand l'adresse est hors de la zone Roulez Jeunesse
 * (porte d'entrée 2, `docs/designs/reparation-hors-zone-liste.md`).
 *
 * Pur, sans React : la répartition en trois groupes décide de ce que le client
 * lit (« un réparateur peut venir » ou « personne ne se déplace »), elle doit
 * donc être testée seule.
 */

export const TYPE_DOMICILE = 'Réparation à domicile';

/**
 * Un atelier de `/zones/availability`, tel que le range `parse_all_shops`
 * (`{ value }`, `details` en tableau), au format que lit la carte de
 * l'annuaire : `details` objet, horaires en `weekdayDescriptions`.
 */
export function versAnnuaire(entree) {
  const value = (entree && entree.value) || {};
  let brut = Array.isArray(value.details) ? value.details[0] : value.details;
  if (typeof brut === 'string') {
    try {
      brut = JSON.parse(brut);
    } catch (e) {
      brut = null;
    }
  }
  const details = brut && typeof brut === 'object' ? brut : {};
  let { horaires } = details;
  if (!horaires && typeof details.horaires_formatted === 'string') {
    horaires = { weekdayDescriptions: details.horaires_formatted.split('\n') };
  }
  return { ...value, details: { ...details, horaires: horaires || null } };
}

const seDeplace = (shop) => {
  const types = shop.details && shop.details.typologie_etablissement;
  return [].concat(types || []).includes(TYPE_DOMICILE);
};

/**
 * Trois groupes, dans cet ordre d'affichage :
 * - les partenaires Fixer Lite, seuls à se réserver depuis la page ;
 * - les autres réparateurs à domicile de l'annuaire (« Voir la fiche ») ;
 * - les ateliers, où l'on apporte son vélo.
 *
 * Un partenaire est reconnu à `fixer_lite.enabled` sur l'atelier renvoyé par
 * l'API (FIXERLIGHT-054) : tant qu'elle ne l'envoie pas, le groupe est vide et
 * rien d'autre ne change. L'ordre de l'API est gardé dans chaque groupe.
 */
export function grouperHorsZone(shops) {
  const groupes = { partenaires: [], itinerants: [], ateliers: [] };
  (shops || []).map(versAnnuaire).forEach((shop) => {
    if (isFixerLiteEnabled(shop)) groupes.partenaires.push(shop);
    else if (seDeplace(shop)) groupes.itinerants.push(shop);
    else groupes.ateliers.push(shop);
  });
  return groupes;
}
